var $ = require('jquery');

$(window).on('resize', function() {
    heroSecondary();
})

$(window).on('load', function() {
    heroSecondary();
})

function heroSecondary() {
    let parent = $('.hero-secondary--style-dual.hero-secondary--masked');
    if ( $(window).width() <= 768 ) {
        let content = parent.find('.hero-secondary__content');
        let visual = parent.find('.hero-secondary__visuals');
        parent.css('height', content.outerHeight(true) + 361);
    } else {
        parent.attr('style', '');
    }
}